import React from 'react';
import { Globe } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';
import '../styles/LanguageSwitcher.css';

const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'tr', label: 'TR' },
];

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { lang, setLang, t } = useI18n();

  return (
    <div className={`lang-switcher lang-switcher-${variant}`} role="group" aria-label={t('language.switchTo')}>
      <Globe size={14} className="lang-switcher-icon" aria-hidden="true" />
      {LANGS.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={`lang-switcher-btn ${lang === code ? 'active' : ''}`}
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
